package com.sddamico.draftmachine.util

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.api.apiGet
import com.sddamico.draftmachine.models.LeagueCardResponse
import kotlinx.serialization.builtins.ListSerializer

/**
 * Fetches the Machine room dashboard (`GET /api/dashboard`) once on first composition. The caller
 * is expected to already be authenticated, so any error (including a 401) surfaces as
 * [LoadState.Failed].
 */
@Composable
fun rememberDashboard(): LoadState<List<LeagueCardResponse>> =
  rememberApiResource { apiGet("/api/dashboard", ListSerializer(LeagueCardResponse.serializer())) }
